import { h } from 'preact'
import classNames from 'classnames'

import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'

export interface TimezoneSelector {
    title: string,
    value: string
}
export type TimezoneList = Array<TimezoneSelector>

function normalizeTimzone (timezoneList: TimezoneList, onChange: Function) {
    return timezoneList.map((timezone: TimezoneSelector) => {
        return {
            value: timezone.value,
            title: timezone.title,
            onClick: (e: Event) => onChange((e.target as HTMLElement).getAttribute('value')),
            variant: 'primary'
        }
    })
}

const TimezoneSelector = ({timezones, selected, onChange, error}: {
    timezones: TimezoneList,
    selected: TimezoneSelector | undefined,
    onChange: Function,
    error?: string | undefined
}) => {
    const normalizedTimezone = timezones && normalizeTimzone(timezones, onChange)

    const DropdownText = () => {
        if(timezones.length === 0) return 'Loading timezones...'
        return selected ?
            <span class='selected'>
            <div class='truncated'>{selected.title}</div>
        </span>
            : 'Choose a timezone'
    }

    const className = classNames('timezone-selector qa-timezone-selector', error && 'error', !selected && 'no-timezone-selected-message')

    return <div class='timezone-selector-wrapper'>
        <DropdownControl
            align='adjust'
            // @ts-ignore
            trigger={<ButtonControl title={<DropdownText />} class={className} icon={'arrowDropdown'} />}
            items={normalizedTimezone}
            hasSearch={true}
        />
        {error && <span class='error'>{error}</span>}
    </div>
}

export default TimezoneSelector
